import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import PageHeader from '../../components/PageHeader/PageHeader';
import { HoldingsPage } from '../Holdings/HoldingsPage';
import { CustodianTablePage } from '../CustodianTable/CustodianTable';
import { PortfolioTablePage } from '../PortfolioTable/PortfolioTable';
import { OTCDatabasePage } from '../OTCDatabase/OTCDatabasePage';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <div>
      {value === index && <Box sx={{ flex: 1, minHeight: 0 }}>{children}</Box>}
    </div>
  );
}

const DatabasePage: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <PageHeader
        title="Database"
        subtitle="Manage your portfolio data, custodian information, and holdings"
      />

      <Paper
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="database tabs"
          >
            <Tab label="Portfolio" data-testid="tab-portfolio" />
            <Tab label="Custodian" data-testid="tab-custodian" />
            <Tab label="Holdings" data-testid="tab-holdings" />
            <Tab label="OTC" data-testid="tab-otc" />
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <PortfolioTablePage />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <CustodianTablePage />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <HoldingsPage />
        </TabPanel>

        <TabPanel value={currentTab} index={3}>
          <OTCDatabasePage />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default DatabasePage;
